import * as actionTypes from "../../actions/actionTypes";
const availabilitySchedule = (state = { unavailable_slots: [] }, action) => {
  const pad = (str, max) => {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
  };

  const slotCount = (slot, slotsCount, operation) => {
    const hour = parseInt(slot.split(":")[0]);

    let morningSlots = parseInt(slotsCount.morningSlots) || 0;
    let afternoonSlots = parseInt(slotsCount.afternoonSlots) || 0;
    let eveningSlots = parseInt(slotsCount.eveningSlots) || 0;

    if (hour < 12)
      morningSlots = operation === "add" ? morningSlots + 1 : morningSlots - 1;
    else if (hour >= 12 && hour < 18)
      afternoonSlots =
        operation === "add" ? afternoonSlots + 1 : afternoonSlots - 1;
    else
      eveningSlots = operation === "add" ? eveningSlots + 1 : eveningSlots - 1;

    return {
      morningCount: pad(morningSlots.toString(), 2),
      afternoonCount: pad(afternoonSlots.toString(), 2),
      eveningCount: pad(eveningSlots.toString(), 2),
    };
  };

  switch (action.type) {
    case actionTypes.SET_AVAILABILITY_SCHEDULE:
      return { ...state, ...action.payload };
    case actionTypes.SET_UNAVAILABILITY_SCHEDULE: {
      const updatedObj = [...state.unavailable_slots];

      const slot = action.payload;

      let slotCountRes;

      if (!updatedObj.includes(action.payload)) {
        slotCountRes = slotCount(
          slot,
          {
            morningSlots: state.count.morningCount,
            afternoonSlots: state.count.afternoonCount,
            eveningSlots: state.count.eveningCount,
          },
          "add"
        );

        updatedObj.push(action.payload);
      } else {
        slotCountRes = slotCount(slot, {
          morningSlots: state.count.morningCount,
          afternoonSlots: state.count.afternoonCount,
          eveningSlots: state.count.eveningCount,
        });
        updatedObj.splice(updatedObj.indexOf(action.payload), 1);
      }

      return {
        ...state,
        count: slotCountRes,
        unavailable_slots: updatedObj,
      };
    }
    default:
      return state;
  }
};

export default availabilitySchedule;
